/* Types */ // Для глоба нельзя использовать literal, только строка. Поэтому везде import.meta.glob
// https://github.com/vitejs/vite/discussions/15397

export const ICONS = {
  'add-circle': import.meta.glob('@/assets/icons/add-circle.svg', {
    query: '?raw',
    import: 'default',
  }),
  alert: import.meta.glob('@/assets/icons/alert.svg', {
    query: '?raw',
    import: 'default',
  }),
  'alert-circle': import.meta.glob('@/assets/icons/alert-circle.svg', {
    query: '?raw',
    import: 'default',
  }),
  'arrow-left': import.meta.glob('@/assets/icons/arrow-left.svg', {
    query: '?raw',
    import: 'default',
  }),
  'arrow-right': import.meta.glob('@/assets/icons/arrow-right.svg', {
    query: '?raw',
    import: 'default',
  }),
  'arrow-small': import.meta.glob('@/assets/icons/arrow-small.svg', {
    query: '?raw',
    import: 'default',
  }),
  'arrow-up': import.meta.glob('@/assets/icons/arrow-up.svg', {
    query: '?raw',
    import: 'default',
  }),
  'birthday-cake': import.meta.glob('@/assets/icons/birthday-cake.svg', {
    query: '?raw',
    import: 'default',
  }),
  'bubble-chat': import.meta.glob('@/assets/icons/bubble-chat.svg', {
    query: '?raw',
    import: 'default',
  }),
  calendar: import.meta.glob('@/assets/icons/calendar.svg', {
    query: '?raw',
    import: 'default',
  }),
  call: import.meta.glob('@/assets/icons/call.svg', {
    query: '?raw',
    import: 'default',
  }),
  calling: import.meta.glob('@/assets/icons/calling.svg', {
    query: '?raw',
    import: 'default',
  }),
  camera: import.meta.glob('@/assets/icons/camera.svg', {
    query: '?raw',
    import: 'default',
  }),
  check: import.meta.glob('@/assets/icons/check.svg', {
    query: '?raw',
    import: 'default',
  }),
  'checkmark-circle': import.meta.glob('@/assets/icons/checkmark-circle.svg', {
    query: '?raw',
    import: 'default',
  }),
  'cheese-cake': import.meta.glob('@/assets/icons/cheese-cake.svg', {
    query: '?raw',
    import: 'default',
  }),
  'chef-hat': import.meta.glob('@/assets/icons/chef-hat.svg', {
    query: '?raw',
    import: 'default',
  }),
  'clock-01': import.meta.glob('@/assets/icons/clock-01.svg', {
    query: '?raw',
    import: 'default',
  }),
  'clock-02': import.meta.glob('@/assets/icons/clock-02.svg', {
    query: '?raw',
    import: 'default',
  }),
  'clock-03': import.meta.glob('@/assets/icons/clock-03.svg', {
    query: '?raw',
    import: 'default',
  }),
  close: import.meta.glob('@/assets/icons/close.svg', {
    query: '?raw',
    import: 'default',
  }),
  'close-bigger': import.meta.glob('@/assets/icons/close-bigger.svg', {
    query: '?raw',
    import: 'default',
  }),
  'container-truck': import.meta.glob('@/assets/icons/container-truck.svg', {
    query: '?raw',
    import: 'default',
  }),
  copy: import.meta.glob('@/assets/icons/copy.svg', {
    query: '?raw',
    import: 'default',
  }),
  'coupon-percent': import.meta.glob('@/assets/icons/coupon-percent.svg', {
    query: '?raw',
    import: 'default',
  }),
  'credit-card': import.meta.glob('@/assets/icons/credit-card.svg', {
    query: '?raw',
    import: 'default',
  }),
  'credit-card-add': import.meta.glob('@/assets/icons/credit-card-add.svg', {
    query: '?raw',
    import: 'default',
  }),
  'credit-card-pos': import.meta.glob('@/assets/icons/credit-card-pos.svg', {
    query: '?raw',
    import: 'default',
  }),
  'customer-support': import.meta.glob('@/assets/icons/customer-support.svg', {
    query: '?raw',
    import: 'default',
  }),
  discount: import.meta.glob('@/assets/icons/discount.svg', {
    query: '?raw',
    import: 'default',
  }),
  dish: import.meta.glob('@/assets/icons/dish.svg', {
    query: '?raw',
    import: 'default',
  }),
  'dish-packing': import.meta.glob('@/assets/icons/dish-packing.svg', {
    query: '?raw',
    import: 'default',
  }),
  edit: import.meta.glob('@/assets/icons/edit.svg', {
    query: '?raw',
    import: 'default',
  }),
  'expand-down': import.meta.glob('@/assets/icons/expand-down.svg', {
    query: '?raw',
    import: 'default',
  }),
  'expand-right': import.meta.glob('@/assets/icons/expand-right.svg', {
    query: '?raw',
    import: 'default',
  }),
  filter: import.meta.glob('@/assets/icons/filter.svg', {
    query: '?raw',
    import: 'default',
  }),
  gift: import.meta.glob('@/assets/icons/gift.svg', {
    query: '?raw',
    import: 'default',
  }),
  home: import.meta.glob('@/assets/icons/home.svg', {
    query: '?raw',
    import: 'default',
  }),
  hot: import.meta.glob('@/assets/icons/hot.svg', {
    query: '?raw',
    import: 'default',
  }),
  hourglass: import.meta.glob('@/assets/icons/hourglass.svg', {
    query: '?raw',
    import: 'default',
  }),
  'information-circle': import.meta.glob(
    '@/assets/icons/information-circle.svg',
    {
      query: '?raw',
      import: 'default',
    },
  ),
  'kitchen-utensils': import.meta.glob('@/assets/icons/kitchen-utensils.svg', {
    query: '?raw',
    import: 'default',
  }),
  location: import.meta.glob('@/assets/icons/location.svg', {
    query: '?raw',
    import: 'default',
  }),
  'location-fill': import.meta.glob('@/assets/icons/location-fill.svg', {
    query: '?raw',
    import: 'default',
  }),
  logout: import.meta.glob('@/assets/icons/logout.svg', {
    query: '?raw',
    import: 'default',
  }),
  mail: import.meta.glob('@/assets/icons/mail.svg', {
    query: '?raw',
    import: 'default',
  }),
  menu: import.meta.glob('@/assets/icons/menu.svg', {
    query: '?raw',
    import: 'default',
  }),
  minus: import.meta.glob('@/assets/icons/minus.svg', {
    query: '?raw',
    import: 'default',
  }),
  money: import.meta.glob('@/assets/icons/money.svg', {
    query: '?raw',
    import: 'default',
  }),
  monocle: import.meta.glob('@/assets/icons/monocle.svg', {
    query: '?raw',
    import: 'default',
  }),
  navigation: import.meta.glob('@/assets/icons/navigation.svg', {
    query: '?raw',
    import: 'default',
  }),
  notification: import.meta.glob('@/assets/icons/notification.svg', {
    query: '?raw',
    import: 'default',
  }),
  pan: import.meta.glob('@/assets/icons/pan.svg', {
    query: '?raw',
    import: 'default',
  }),
  'payment-success': import.meta.glob('@/assets/icons/payment-success.svg', {
    query: '?raw',
    import: 'default',
  }),
  plus: import.meta.glob('@/assets/icons/plus.svg', {
    query: '?raw',
    import: 'default',
  }),
  reload: import.meta.glob('@/assets/icons/reload.svg', {
    query: '?raw',
    import: 'default',
  }),
  remove: import.meta.glob('@/assets/icons/remove.svg', {
    query: '?raw',
    import: 'default',
  }),
  search: import.meta.glob('@/assets/icons/search.svg', {
    query: '?raw',
    import: 'default',
  }),
  setting: import.meta.glob('@/assets/icons/setting.svg', {
    query: '?raw',
    import: 'default',
  }),
  'shopping-bag': import.meta.glob('@/assets/icons/shopping-bag.svg', {
    query: '?raw',
    import: 'default',
  }),
  shuffle: import.meta.glob('@/assets/icons/shuffle.svg', {
    query: '?raw',
    import: 'default',
  }),
  'square-lock': import.meta.glob('@/assets/icons/square-lock.svg', {
    query: '?raw',
    import: 'default',
  }),
  star: import.meta.glob('@/assets/icons/star.svg', {
    query: '?raw',
    import: 'default',
  }),
  'star-circle': import.meta.glob('@/assets/icons/star-circle.svg', {
    query: '?raw',
    import: 'default',
  }),
  task: import.meta.glob('@/assets/icons/task.svg', {
    query: '?raw',
    import: 'default',
  }),
  'thumbs-down': import.meta.glob('@/assets/icons/thumbs-down.svg', {
    query: '?raw',
    import: 'default',
  }),
  'thumbs-up': import.meta.glob('@/assets/icons/thumbs-up.svg', {
    query: '?raw',
    import: 'default',
  }),
  tick: import.meta.glob('@/assets/icons/tick.svg', {
    query: '?raw',
    import: 'default',
  }),
  'tick-double': import.meta.glob('@/assets/icons/tick-double.svg', {
    query: '?raw',
    import: 'default',
  }),
  'time-quarter': import.meta.glob('@/assets/icons/time-quarter.svg', {
    query: '?raw',
    import: 'default',
  }),
  'truck-delivery': import.meta.glob('@/assets/icons/truck-delivery.svg', {
    query: '?raw',
    import: 'default',
  }),
  unavailable: import.meta.glob('@/assets/icons/unavailable.svg', {
    query: '?raw',
    import: 'default',
  }),
  upload: import.meta.glob('@/assets/icons/upload.svg', {
    query: '?raw',
    import: 'default',
  }),
  'user-group': import.meta.glob('@/assets/icons/user-group.svg', {
    query: '?raw',
    import: 'default',
  }),
  view: import.meta.glob('@/assets/icons/view.svg', {
    query: '?raw',
    import: 'default',
  }),
  'view-off': import.meta.glob('@/assets/icons/view-off.svg', {
    query: '?raw',
    import: 'default',
  }),
  wallet: import.meta.glob('@/assets/icons/wallet.svg', {
    query: '?raw',
    import: 'default',
  }),
}

export type ColorName = '--fillColor' | '--strokeColor'

export type IconsKeys = keyof typeof ICONS
